import { useRef, useCallback } from "react";

function useEvent(callback) {
	const handlerRef = useRef(callback);
	handlerRef.current = callback;
	return useCallback((...args) => handlerRef.current?.(...args), []);
}

export default useEvent;
